import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=eb6a89f0"
import script from "./inicio.vue?vue&type=script&lang=js"
export * from "./inicio.vue?vue&type=script&lang=js"
import style0 from "./inicio.vue?vue&type=style&index=0&id=eb6a89f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports